import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import defaultFlags from '../initFlags/featureFlags';

// Amplitude hands back the assigned bucket as `{ key, value, payload }`. `key` is what the
// newer SDK populates and `value` is the legacy field, so read `value` first and fall back
// to `key` before comparing.
const readVariantValue = variantData => {
  const value = variantData?.value ?? variantData?.key;
  return typeof value === 'string' ? value.trim().toLowerCase() : value;
};

// Buckets that mean "this user is not in the experiment". Anything else - `on`, `treatment`,
// `treatment-a`, `v2`, `slab-1`, ... - is an active variant and must resolve to its own
// payload, otherwise every multi-variant experiment reads as disabled.
const OFF_VARIANT_VALUES = ['off', 'control', 'false'];

const isAmplitudeVariantOn = variantData => {
  const value = readVariantValue(variantData);
  if (value == null || value === '') {
    return false;
  }
  return !OFF_VARIANT_VALUES.includes(value);
};

const getAmplitudeVariantPayload = (name, states, existingflagValue) => {
  if (states?.flags?.amplitude_experiment_flag == 'ON' && states?.variants && name) {
    const variantData = _get(states?.variants, [name.toLowerCase()]);
    if (variantData) {
      if (isAmplitudeVariantOn(variantData)) {
        return variantData.payload;
      } else {
        return '';
      }
    } else {
      const isMissingFlagValue =
        existingflagValue == null ||
        (typeof existingflagValue === 'object' && _isEmpty(existingflagValue));
      return isMissingFlagValue ? defaultFlags?.flags?.[name?.toLowerCase()] : existingflagValue;
    }
  }
  return existingflagValue;
};

const getAmplitudeExperimentVariant = (name, states) => {
  if (states?.flags?.amplitude_experiment_flag === 'ON' && states?.variants && name) {
    const variantData = _get(states?.variants, [name.toLowerCase()]);
    if (variantData) {
      return isAmplitudeVariantOn(variantData);
    }
  }
  return false;
};

const getAmplitudeVariantFlag = (name, states, existingflagValue) => {
  if (states?.flags?.amplitude_experiment_flag == 'ON' && states?.variants && name) {
    const variantData = _get(states?.variants, [name.toLowerCase()]);
    if (variantData) {
      return isAmplitudeVariantOn(variantData);
    } else {
      return existingflagValue;
    }
  }
  return existingflagValue;
};

const getAmplitudeVariantPayloadMap = (names = [], states) => {
  const ABFlagObj = {};
  if (
    states?.flags?.amplitude_experiment_flag == 'ON' &&
    states?.variants &&
    names &&
    names.length > 0
  ) {
    for (var i = 0; i < names.length; i++) {
      var name = names[i];
      const variantData = _get(states?.variants, [name.toLowerCase()]);
      if (variantData) {
        if (isAmplitudeVariantOn(variantData)) {
          ABFlagObj[name] = variantData.payload;
        }
      }
    }
  }
  return ABFlagObj;
};

export {
  getAmplitudeVariantPayload,
  getAmplitudeVariantFlag,
  getAmplitudeVariantPayloadMap,
  getAmplitudeExperimentVariant,
  isAmplitudeVariantOn
};
